import React, { useEffect } from "react";

const HypercomplyCallback = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authCode = urlParams.get("code");

    if (authCode) {
      // Send the auth code to the opener window (main app)
      if (window.opener) {
        window.opener.postMessage(
          {
            type: "clerk_oauth_authorization",
            authorization_code: authCode,
          },
          "*"
        );

        // Optional: Close this tab/window
        window.close();
      } else {
        console.warn("No opener window found.");
      }
    } else {
      console.error("Authorization code not found in URL.");
    }
  }, []);

  return (
    <div className="p-8 text-center">
      <h2 className="text-xl font-semibold">Finishing authentication...</h2>
      <p>You can close this tab if it doesn’t close automatically.</p>
    </div>
  );
};

export default HypercomplyCallback;
